// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const FileStatusOut = zod.object({
  "id": zod.uuid(),
  "text_chars": zod.union([zod.int(),zod.null()]),
  "text_status": zod.string(),
  "text_truncated": zod.boolean()
});

export type FileStatusOut = zod.input<typeof FileStatusOut>;
export type FileStatusOutOutput = zod.output<typeof FileStatusOut>;
